import { ProductType } from '../types';
import { AccessProtectedPage } from './AccessProtectedPage';
import { useCallback } from 'react';
import Canvas from './components/Canvas';

export const CanvasPage = () => {
  const render = useCallback(() => <Canvas />, []);

  return (
    <AccessProtectedPage
      productType={ProductType.CANVAS}
      renderContent={render}
    />
  );
};
